import { render, staticRenderFns } from "./myaccount-logout.vue?vue&type=template&id=a3d29ee4"
import script from "./myaccount-logout.vue?vue&type=script&lang=js"
export * from "./myaccount-logout.vue?vue&type=script&lang=js"
import style0 from "./myaccount-logout.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports